import React from 'react';
import Grid from '@material-ui/core/Grid';
import moment from 'moment';
import T from 'i18n-react';
import CategoryChip from '../../core/News/CategoryChip';
import makeStyles from '@material-ui/core/styles/makeStyles';
import type { ArticleProps } from '../../core/Articles/props';
import AnnouncementGrid from '../../core/News/components/AnnouncementGrid';
import RowGrid from '../../core/News/components/RowGrid';
import SubjectGrid from '../../core/News/components/SubjectGrid';
import { SERVICE_COLOR_2 } from '../../core/styles/variables';

const useStyles = makeStyles((theme) => ({
  category: {
    lineHeight: 1,
    marginLeft: 40,
    [theme.breakpoints.down(768)]: {
      marginLeft: 10,
    },
  },
}));

type RowProps = Pick<ArticleProps, 'subject' | 'announcedAt' | 'category'> & {
  href: string,
  border?: boolean,
};

const Row = ({ href, subject, announcedAt, category, border }: RowProps) => {
  const classes = useStyles({ border });

  return (
    <RowGrid
      container
      alignItems="center"
      border={border}
      borderColor={SERVICE_COLOR_2}
    >
      <AnnouncementGrid item>
        {moment(announcedAt).format(T.translate('moment.date'))}
      </AnnouncementGrid>
      <Grid item className={classes.category}>
        <CategoryChip {...category} />
      </Grid>
      <SubjectGrid item component="a" href={href} xs={12} sm="auto">
        {subject}
      </SubjectGrid>
    </RowGrid>
  );
};

export default Row;
